import * as React from "react";
import type { SVGProps } from "react";
const SvgPcIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="pc_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 64A170.667 170.667 0 0 0 0 234.667v384a170.667 170.667 0 0 0 170.667 170.666h298.666v85.334h-256V960h597.334v-85.333h-256v-85.334h298.666A170.667 170.667 0 0 0 1024 618.667v-384A170.667 170.667 0 0 0 853.333 64H170.667zM85.333 234.667a85.333 85.333 0 0 1 85.334-85.334h682.666a85.333 85.333 0 0 1 85.334 85.334v384A85.333 85.333 0 0 1 853.333 704H170.667a85.333 85.333 0 0 1-85.334-85.333v-384z"
    />
  </svg>
);
export default SvgPcIcon;
